import { Component, Inject, ViewChild, ElementRef } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogBase, ObjectTypeInfo, TypeCategoryInfo } from 't4core';
import { LocationUserInfo } from 't4core';
import { ProductType, Additive, ObjectTypeClassInfo, ObjectTypeClassAttributesInfo } from 't4core';
import { T4DatatableWidget } from '../../../../t4common';
import { OneWayAdmin } from '../../../OneWayAdmin/owadmin.module';
import { ImageType, T4Image } from 't4core';
import { TypeAttributeInfo } from '../../../../../projects/t4core/src/public-api';
import { ObjectTypeClassAttributeDialog } from '../ObjectTypeClassAttributeDialog/ObjectTypeClassAttributeDialog';

@Component({
    styleUrls: ['CreateObjectTypeDialog.css'],
    selector: 'CreateObjectTypeDialog',
    templateUrl: 'CreateObjectTypeDialog.html',
})
export class CreateObjectTypeDialog extends DialogBase {
    public addonToSave: ObjectTypeInfo;
    public cat: TypeCategoryInfo;
  public myCategories: TypeCategoryInfo[];
  public image: T4Image = new T4Image();
  public objectTypeclasses: ObjectTypeClassInfo[];
  public Attributes: ObjectTypeClassAttributesInfo[]
  public typeAttrubutes: TypeAttributeInfo[] = [];
  public editRentalObjectType: boolean = false;
  public overidden: ObjectTypeClassInfo[];
  public typeClassId: number;

  @ViewChild("tblContent") private tblContent: T4DatatableWidget;
  @ViewChild("txtFile") private txtFile: ElementRef;

    constructor(
        public dialogRef: MatDialogRef<CreateObjectTypeDialog>,
        @Inject(MAT_DIALOG_DATA) public data: { allAddons: ObjectTypeInfo[], inheritedAddons: ObjectTypeInfo[], editable: boolean, addonToChange: ObjectTypeInfo } 
    ) {
        super("CreateObjectTypeDialog");
    }

    public async ngOnInit() {
        if (this.data.addonToChange) {
            this.addonToSave = this.data.addonToChange;
          this.editRentalObjectType = true;
            await this.clearSuffix();
        }
        else {
            this.addonToSave = new ObjectTypeInfo;
            this.addonToSave.VATPercentage = 0;
            this.addonToSave.UnlimitedRelations = true;
      }
      this.image = await this.Api.get<T4Image>("Data/GetImage", { type: ImageType.ObjectType, entityId: this.addonToSave.Id });
      await this.getObjectTypeClassInfo();
      if (this.editRentalObjectType) {
        this.overidden = this.objectTypeclasses.filter(o => o.OverridesClassId == this.addonToSave.TypeClassId);
        if (this.overidden.length != 0) {
          this.typeClassId = this.overidden[0].Id
        }
        else {
          this.typeClassId = this.addonToSave.TypeClassId
        }
        ////console.log("data", this.data);
        ////var res = await this.Api.get<ObjectTypeClassAttributesInfo[]>("Settings/GetObjectTypeClassAttributesByClassId", { classId: this.typeClassId });

        //this.Attributes = this.addonToSave;
        
      }
    }

    public async clearSuffix() {

        if (this.addonToSave.Height && this.addonToSave.Height.indexOf("cm")) {
            this.addonToSave.Height = this.addonToSave.Height.replace("cm", "");
            this.addonToSave.Width.trim();
        }

        if (this.addonToSave.Width && this.addonToSave.Width.indexOf("cm")) {
            this.addonToSave.Width = this.addonToSave.Width.replace("cm", "");
            this.addonToSave.Width.trim();
        }

        if (this.addonToSave.Length && this.addonToSave.Length.indexOf("cm")) {
            this.addonToSave.Length = this.addonToSave.Length.replace("cm", "");
            this.addonToSave.Length.trim();
        }

        if (this.addonToSave.TotalWeight && this.addonToSave.TotalWeight.indexOf("kg")) {
            this.addonToSave.TotalWeight = this.addonToSave.TotalWeight.replace("kg", "");
            this.addonToSave.TotalWeight.trim();
        }

        if (this.addonToSave.MaxLoad && this.addonToSave.MaxLoad.indexOf("kg")) {
            this.addonToSave.MaxLoad = this.addonToSave.MaxLoad.replace("kg", "");
            this.addonToSave.MaxLoad.trim();
        }

    }

    public async addSuffix() {

        if (this.addonToSave.Height && !this.addonToSave.Height.indexOf("cm")) {
            this.addonToSave.Height.trim();
            this.addonToSave.Height = this.addonToSave.Height + " cm";
        }

        if (this.addonToSave.Width && !this.addonToSave.Width.indexOf("cm")) {
            this.addonToSave.Width.trim();
            this.addonToSave.Width = this.addonToSave.Width + " cm";
        }

        if (this.addonToSave.Length && !this.addonToSave.Length.indexOf("cm")) {
            this.addonToSave.Length.trim();
            this.addonToSave.Length = this.addonToSave.Length + " cm";
        }

        if (this.addonToSave.TotalWeight && !this.addonToSave.TotalWeight.indexOf("kg")) {
            this.addonToSave.TotalWeight.trim();
            this.addonToSave.TotalWeight = this.addonToSave.TotalWeight + " kg";
        }

        if (this.addonToSave.MaxLoad && !this.addonToSave.MaxLoad.indexOf("kg")) {
            this.addonToSave.MaxLoad.trim();
            this.addonToSave.MaxLoad = this.addonToSave.MaxLoad + " kg";
        }

    }

    public toggleAddonAvailability(event) {
        this.addonToSave.IsHidden = !event.checked;
    }

  public async save() {
      var token = this.beginLoad("T4.Settings.SaveAddonDialog.msgCreating", "Saving addon", null);

      this.addSuffix();

    var typeId = await this.Api.post<any>("RentalObject/SaveObjectType", this.addonToSave, {});
      this.endLoad(token);
    if (typeId) {
      console.log("attributestosave", this.addonToSave.Attributes);

      const attributesToSave = this.addonToSave.Attributes
        .map(attr => ({
          AttributeId: attr.AttributeId,
          RentalObjectTypeId: typeId,
          AttributeValue: attr.Value
        }));
      var res = await this.Api.post<any>("Settings/SaveTypeAttributes", attributesToSave);
          this.dialogRef.close();
      }
      else {
          alert("Failed, try again!");
      }

    }
  public beginUpload() {
    this.txtFile.nativeElement.click();
  }
  public upload(files: FileList) {
    let me = this;
    let file = files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = async function () {
      console.log(reader.result);
      await me.Api.post<T4Image>("Data/SetImage", "\"" + reader.result.toString() + "\"", { type: ImageType.ObjectType, entityId: me.addonToSave.Id });
      me.image = await me.Api.get<T4Image>("Data/GetImage", { type: ImageType.ObjectType, entityId: me.addonToSave.Id });
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  public async getObjectTypeClassInfo() {
    var res = await this.Api.get<ObjectTypeClassInfo[][]>("Settings/GetAllObjectTypeClasses");
    this.objectTypeclasses = [...res[0], ...res[1]];
    this.objectTypeclasses.forEach(a => {
      this.Attributes = [...a.Attributes];
    });
  }
  
  public async onTypeClassSelected(selectedId: number) {
    this.addonToSave.TypeClassId = selectedId;
    this.overidden = this.objectTypeclasses.filter(o => o.OverridesClassId == selectedId);
    if (this.overidden.length != 0) {
      this.Attributes = this.overidden[0].Attributes;
    }
    else {
      this.Attributes = this.objectTypeclasses.find(o => o.Id == selectedId).Attributes;
    }
    this.Attributes.forEach(attr => {
      if (!attr.TypeAttribute) {
        attr.TypeAttribute = {
          Id: null,
          AttributeId: attr.Id,
          RentalObjectTypeId: null,
          AttributeValue: ''
        };
      }
    });
  }

  public async deleteTypeAttribute(attr: TypeAttributeInfo) {
    var token = this.UI.beginLoading("T4.Settings.CreateObjectTypeDialog.msgDeletingAttr", "Deleting Type attributes", null);
    var res = await this.Api.delete<boolean>("Settings/DeleteTypeAttributes", { attrId: attr.Id });
    this.UI.loaderCompleted(token);
  }
}
